import {
  Component,
  HostBinding,
  Input,
  SimpleChange,
  SimpleChanges
} from '@angular/core';
import { IStep } from './models/step.interface';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'upsc-stepper2',
  templateUrl: './stepper2.component.html',
  styleUrls: ['./stepper2.component.scss'],
  providers: [DatePipe]
})
export class Stepper2Component {
  @HostBinding('class') public hostClass = 'stepper';

  @Input() public steps: IStep[];
  @Input() public currentStep: number;

  public progress: number;

  public ngOnChanges(changes: SimpleChanges) {
    this.onCurrentStepChanged(changes['currentStep']);
  }

  private onCurrentStepChanged(change: SimpleChange) {
    if (!change || !change.currentValue) {
      return;
    }

    this.setProgress();
  }

  private setProgress() {
    if (!this.steps || !this.steps.length) {
      this.progress = 0;
      return;
    }

    this.steps.forEach(
      (step) => {
        step.isActive = step.order === this.currentStep;
      },
    );

    this.progress = (this.currentStep - 1) * 100 / (this.steps.length - 1);
  }
}
